/**
 * Modell für Paginierung, Sortierung und Filterung der Tabelle. Diese Information wird an die Datenquelle der Tabelle gesendet damit diese
 * die passenden Rows zurückliefert.
 *
 * @author femu
 */
export class TablePageSortAndFilter {

    size: number;
    page: number;
    sortProperty: string;
    sortDirection: 'asc' | 'desc';
    filter: Filter[] = [];

    // ob es sich um ein Refresh handelt, also auch bei sonst komplett gleichen Attributen ein erneutes Laden der Daten erfoglen soll
    refresh: boolean;

    toString() {
        return JSON.stringify(this);
    }

    static create(size: number,
                  page: number,
                  sortProperty: string,
                  sortDirection: 'asc' | 'desc',
                  filter: Filter[]): TablePageSortAndFilter {
        const tpsf: TablePageSortAndFilter = new TablePageSortAndFilter();
        tpsf.size = size;
        tpsf.page = page;
        tpsf.sortProperty = sortProperty;
        tpsf.sortDirection = sortDirection;
        tpsf.filter = filter;
        return tpsf;
    }
}

type SimpleFilterValue = string | number | Date;

/**
 * Modell für Filterung.
 */
export interface Filter {
    /**
     * Name der Property, nach der gefiltert werden soll.
     */
    name: string;

    /**
     * Der Filterwert. Es handelt sich entweder um einen einzelnen Wert oder um ein "flaches" Object mit verschiedenen Werten
     * (z.B. "from" und "to" bei einem Bereichsfilter).
     *
     * Arrays werden hier nicht unterstützt. Stattdessen muss für eine Mehrfachauswahl das Filter-Objekt für die Property
     * mehrfach angegeben werden in TablePageSortAndFilter.
     * Das ist nicht unbedingt intuitiv, wurde aber aus Gründen der Abwärtskompatibilität so beibehalten.
     *
     * Die Variante mit "from" und "to" ist ein Spezialfall der Varainte "Object", der verwendet werden soll, falls es sich um einen
     * Bereichsfilter handelt (z.B. Datumsbereich).
     */
    value: SimpleFilterValue | { [key: string]: SimpleFilterValue; } | { from: SimpleFilterValue, to: SimpleFilterValue };
}
